module.exports = __webpack_public_path__ + "static/TTNormsPro-Italic-e507ccf8f70e4d559c42f4e66143ce35.woff2";